

export const MESSAGE_NOTIFICATION_RECEIVED = 'NOTIFICATION_RECEIVED';

export const notificationReceived = (notification) => {
    return {
        type: MESSAGE_NOTIFICATION_RECEIVED,
        notification,
    };
};